import React from 'react';
import { LoginLayout } from 'layout';
import '@isyc-react/design/main';
import 'assets/css/login.css';
import { CheckPasswordForm } from 'common/auth/modules/pods/login';
export const CheckPasswordScene = () => {
    return (React.createElement(LoginLayout, null,
        React.createElement(CheckPasswordForm, { successButton: true })));
};
